/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request body for user login
 */
export interface LoginRequest {
  username: string;
  password: string;
  rememberMe?: boolean;
}
